import { useQuery } from 'react-query';
import { getData, QueryKeyConfig } from '../api/api-helper';

export const useLoadData = <T>(config?: QueryKeyConfig, isEnabled?: boolean) => {
  if (!config) {
    return {
      data: undefined,
      isLoading: false,
      isFetching: false,
      isError: false,
      error: undefined,
      refetch: () => {},
    };
  }

  return useQuery<T>({
    queryKey: [...config.queryKey],
    queryFn: () => getData(config.route, config.params),
    keepPreviousData: true,
    enabled: isEnabled !== false && !!(config.isEnabled || config.isEnabled === undefined),
    retry: config.retry,
  });
};
